import { AfterViewInit, Component, OnInit, NgZone } from '@angular/core';
import { PROJECTS } from '@core/enum/projects.enum';
import { ModalErrorConfig } from '@core/interfaces/modal-error-config.interface';
import { MessageBusService, MicroFrontendRouter } from '@xdig/ng-microkernel/micro-frontend';
import { ModalService } from '../../modal.service';
import { ACCOUNT_OPENED_CONFIG } from './account-opened.component.config';
import { ftdUrl } from '@core/layouts/default/default.config';

@Component({
  selector: 'shell-account-opened',
  templateUrl: './account-opened.component.html',
  styleUrls: ['./account-opened.component.scss'],
})
export class AccountOpenedComponent implements OnInit {
  config: ModalErrorConfig;
  modalError: any;

  constructor(
    private modalService: ModalService,
    public microFrontendRouter: MicroFrontendRouter,
    public messageBus: MessageBusService,
    public ngZone: NgZone,
  ) {}

  closeModal() {
    switch (this.modalError?.project) {
      case PROJECTS.ACC:
        if (this.modalError.error && this.modalError.error.isFraud) {
          this.microFrontendRouter.navigateByUrl('/inicio', 'inicio');
          window.location.href = window.location.origin;
        } else {
          window.location.href = window.location.origin;
        }

        break;
      case PROJECTS.PLD:
        this.microFrontendRouter.navigateByUrl('/inicio', 'inicio');
        break;
      case PROJECTS.FTD:
         window.location.href = window.location.origin + ftdUrl.firstPage;
        break;
      case PROJECTS.BIOMETRICS:
        window.location.href = window.location.origin;
        break;

      case PROJECTS.SHELL:
        window.location.href = window.location.origin;
        break;
    }
    this.modalService.close();
    window.location.reload();
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.ngZone.run(() => {
        this.modalError = this.messageBus.getValue('shell', 'modal.error');
        this.config = ACCOUNT_OPENED_CONFIG.get(this.modalError?.project) as ModalErrorConfig;
      });
    });
  }
}
